"use strict";

exports.__esModule = true;
exports.WidgetVoting = exports.WidgetVisualizer = exports.WidgetVideo = exports.WidgetTextBlock = exports.WidgetTelevision = exports.WidgetTable = exports.WidgetSportRecords = exports.WidgetSocial = exports.WidgetSectionList = exports.WidgetRotatingArticle = exports.WidgetProfile = exports.WidgetPrivateContentBoundary = exports.WidgetPhotoGallery = exports.WidgetPhoto = exports.WidgetPersons = exports.WidgetPartners = exports.WidgetMultiblock = exports.WidgetImageAd = exports.WidgetIframe = exports.WidgetFormattedText = exports.WidgetFAQ = exports.WidgetExternal = exports.WidgetEntityReference = exports.WidgetDocument = exports.WidgetDangerousSource = exports.WidgetCalendarEventList = exports.WidgetBanners = exports.WidgetArticleList = void 0;

var tslib_1 = require("tslib");

var widgets_1 = tslib_1.__importDefault(require("./widgets"));

var ArticleList_1 = tslib_1.__importDefault(require("./widgets/ArticleList"));

exports.WidgetArticleList = ArticleList_1["default"];

var Banners_1 = tslib_1.__importDefault(require("./widgets/Banners"));

exports.WidgetBanners = Banners_1["default"];

var CalendarEventList_1 = tslib_1.__importDefault(require("./widgets/CalendarEventList"));

exports.WidgetCalendarEventList = CalendarEventList_1["default"];

var DangerousSource_1 = tslib_1.__importDefault(require("./widgets/DangerousSource"));

exports.WidgetDangerousSource = DangerousSource_1["default"];

var Document_1 = tslib_1.__importDefault(require("./widgets/Document"));

exports.WidgetDocument = Document_1["default"];

var EntityReference_1 = tslib_1.__importDefault(require("./widgets/EntityReference"));

exports.WidgetEntityReference = EntityReference_1["default"];

var External_1 = tslib_1.__importDefault(require("./widgets/External"));

exports.WidgetExternal = External_1["default"];

var FAQ_1 = tslib_1.__importDefault(require("./widgets/FAQ"));

exports.WidgetFAQ = FAQ_1["default"];

var FormattedText_1 = tslib_1.__importDefault(require("./widgets/FormattedText"));

exports.WidgetFormattedText = FormattedText_1["default"];

var Iframe_1 = tslib_1.__importDefault(require("./widgets/Iframe"));

exports.WidgetIframe = Iframe_1["default"];

var ImageAd_1 = tslib_1.__importDefault(require("./widgets/ImageAd"));

exports.WidgetImageAd = ImageAd_1["default"];

var Multiblock_1 = tslib_1.__importDefault(require("./widgets/Multiblock"));

exports.WidgetMultiblock = Multiblock_1["default"];

var Partners_1 = tslib_1.__importDefault(require("./widgets/Partners"));

exports.WidgetPartners = Partners_1["default"];

var Persons_1 = tslib_1.__importDefault(require("./widgets/Persons"));

exports.WidgetPersons = Persons_1["default"];

var Photo_1 = tslib_1.__importDefault(require("./widgets/Photo"));

exports.WidgetPhoto = Photo_1["default"];

var PhotoGallery_1 = tslib_1.__importDefault(require("./widgets/PhotoGallery"));

exports.WidgetPhotoGallery = PhotoGallery_1["default"];

var PrivateContentBoundary_1 = tslib_1.__importDefault(require("./widgets/PrivateContentBoundary"));

exports.WidgetPrivateContentBoundary = PrivateContentBoundary_1["default"];

var Profile_1 = tslib_1.__importDefault(require("./widgets/Profile"));

exports.WidgetProfile = Profile_1["default"];

var RotatingArticle_1 = tslib_1.__importDefault(require("./widgets/RotatingArticle"));

exports.WidgetRotatingArticle = RotatingArticle_1["default"];

var SectionList_1 = tslib_1.__importDefault(require("./widgets/SectionList"));

exports.WidgetSectionList = SectionList_1["default"];

var Social_1 = tslib_1.__importDefault(require("./widgets/Social"));

exports.WidgetSocial = Social_1["default"];

var SportRecords_1 = tslib_1.__importDefault(require("./widgets/SportRecords"));

exports.WidgetSportRecords = SportRecords_1["default"];

var Table_1 = tslib_1.__importDefault(require("./widgets/Table"));

exports.WidgetTable = Table_1["default"];

var Television_1 = tslib_1.__importDefault(require("./widgets/Television"));

exports.WidgetTelevision = Television_1["default"];

var TextBlock_1 = tslib_1.__importDefault(require("./widgets/TextBlock"));

exports.WidgetTextBlock = TextBlock_1["default"];

var Video_1 = tslib_1.__importDefault(require("./widgets/Video"));

exports.WidgetVideo = Video_1["default"];

var Visualizer_1 = tslib_1.__importDefault(require("./widgets/Visualizer"));

exports.WidgetVisualizer = Visualizer_1["default"];

var Voting_1 = tslib_1.__importDefault(require("./widgets/Voting"));

exports.WidgetVoting = Voting_1["default"];
exports["default"] = widgets_1["default"];